import styled from "styled-components";
import ArrowBack from "../../assets/images/icons/left-arrow.svg";
import ExcellIcon from "../../assets/images/icons/excellIcon.svg";
import CsvIcon from "../../assets/images/icons/csvIcon.svg";
import PdfIcon from "../../assets/images/icons/pdfIcon.svg";
// import Home from '@material-ui/icons/DashboardOutlined';
import Home from "@material-ui/icons/HomeOutlined";
import Companies from "@material-ui/icons/WorkOutlineOutlined";
import Users from "@material-ui/icons/PeopleAltOutlined";
import Industries from "@material-ui/icons/StoreOutlined";
import Partners from "@material-ui/icons/GroupWorkOutlined";
import Customers from "@material-ui/icons/SentimentSatisfiedOutlined";
import License from "@material-ui/icons/AssignmentTurnedInOutlined";
import Revenues from "@material-ui/icons/MonetizationOnOutlined";
import Reports from "@material-ui/icons/AssignmentOutlined";
import MuiAccount from "@material-ui/icons/AccountCircleOutlined";
import Notification from "@material-ui/icons/Notifications";
import ExpandMore from "@material-ui/icons/ExpandMore";
import Menu from "@material-ui/icons/Menu";
import Calendar from "@material-ui/icons/CalendarTodayOutlined";
import Close from "@material-ui/icons/Close";
// import Disable from '@material-ui/icons/NotInterested';
import Update from "@material-ui/icons/Update";
import Search from "@material-ui/icons/Search";
import Installation from "@material-ui/icons/DashboardRounded";
import User from "@material-ui/icons/PermIdentity";
import UserFilled from "@material-ui/icons/Person";
import Info from "@material-ui/icons/Info";
import Add from "@material-ui/icons/Add";
import Accessible from "@material-ui/icons/AccessibleRounded";
import Order from "@material-ui/icons/CardGiftcardOutlined";
import Disable from "@material-ui/icons/Block";
import Delete from "@material-ui/icons/Delete";
import Edit from "@material-ui/icons/Edit";
import Activate from "@material-ui/icons/CheckCircle";
import Dashboard from "@material-ui/icons/Assessment";
import AddCircle from "@material-ui/icons/AddCircleOutline";
import Settings from "@material-ui/icons/Settings";
import ArrowForward from "@material-ui/icons/ArrowForwardIos";
import Brightness7Icon from "@material-ui/icons/Brightness7";
import ClearIcon from '@material-ui/icons/Clear';
import MarkunreadMailboxIcon from '@material-ui/icons/MarkunreadMailbox';
import ListAltIcon from '@material-ui/icons/ListAlt';

interface IIcon {
  size?: number;
}
const Account = styled(MuiAccount)<IIcon>`
  &.MuiSvgIcon-root {
    font-size: ${({ size }) => size && `calc(${size} * 8px)`};
  }
`;

const Icons = {
  Brightness7Icon,
  ArrowBack,
  ExcellIcon,
  PdfIcon,
  CsvIcon,
  Home,
  Companies,
  Users,
  Industries,
  Dashboard,
  User,
  UserFilled,
  Order,
  Delete,
  Activate,
  Partners,
  Customers,
  Account,
  License,
  Revenues,
  Info,
  Add,
  Accessible,
  Installation,
  Reports,
  Notification,
  ExpandMore,
  Menu,
  Calendar,
  Close,
  Edit,
  Disable,
  Update,
  Search,
  AddCircle,
  Settings,
  ArrowForward,
  ClearIcon,
  MarkunreadMailboxIcon,
  ListAltIcon,
};

export { ArrowBack, ExcellIcon, PdfIcon, CsvIcon, Icons };
